import fastdom from 'fastdom';
import init from './custom-element/registry';
const getDevicePixelRatio = () => {
    const isMSMobileDevice = /iemobile/i.test(navigator.userAgent);
    if (isMSMobileDevice) {
        return Math.round(window.screen.availWidth /
            (window.screen.width || window.document.documentElement.clientWidth));
    }
    return window.devicePixelRatio;
};
const STATIC_MEDIA_URL = 'https://static.wixstatic.com/media';
const MEDIA_ROOT_URL = 'https://static.wixstatic.com';
function initCustomElement(services = {}, contextWindow = null) {
    if (typeof window === 'undefined') {
        return;
    }
    const env = {
        staticMediaUrl: STATIC_MEDIA_URL,
        mediaRootUrl: MEDIA_ROOT_URL,
        experiments: {},
        devicePixelRatio: getDevicePixelRatio(),
    };
    const define = init(contextWindow);
    if (define) {
        define(Object.assign({ mutationService: fastdom }, services), env);
    }
}
export { initCustomElement };
//# sourceMappingURL=customElementInit.js.map